import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class NotificationRoutingApi extends BaseApi {
    constructor(client) { super(client, '/notification-routing'); }

    async #call(operation) {
        try { return (await operation()).data; }
        catch (error) { throw ApiError.fromResponse(error); }
    }

    // Without params the API preserves the historical array response. Supplying
    // paging/search params opts into the bounded catalog result envelope.
    catalog(params) {
        return this.#call(() => this.client.get(`${this.basePath}/catalog`, params ? { params } : undefined));
    }
    listManagementEvents(params = {}) { return this.#call(() => this.client.get(`${this.basePath}/events`, { params })); }
    managementEventWorkspace(eventName) {
        return this.#call(() => this.client.get(`${this.basePath}/events/${encodeURIComponent(eventName)}/workspace`));
    }
    listRecordSources(eventName, params = {}) {
        return this.#call(() => this.client.get(`${this.basePath}/events/${encodeURIComponent(eventName)}/sources`, { params }));
    }
    listPolicies(params = {}) { return this.#call(() => this.client.get(`${this.basePath}/policies`, { params })); }
    getPolicy(id) { return this.#call(() => this.client.get(`${this.basePath}/policies/${id}`)); }
    createPolicy(data) { return this.#call(() => this.client.post(`${this.basePath}/policies`, data)); }
    updateDraft(id, data) { return this.#call(() => this.client.put(`${this.basePath}/policies/${id}/draft`, data)); }
    deleteDraft(id, data) {
        return this.#call(() => this.client.delete(`${this.basePath}/policies/${id}/draft`, { data }));
    }
    validateDraft(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/validate`, data)); }
    audienceInspection(id, data) {
        return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/audience-inspection`, data));
    }
    simulate(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/simulate`, data)); }
    getVerification(id, verificationId) {
        return this.#call(() => this.client.get(`${this.basePath}/policies/${id}/verifications/${verificationId}`));
    }
    verificationRecipients(id, verificationId) {
        return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/verifications/${verificationId}/recipients`, {}));
    }
    previewDeliver(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/preview-deliver`, data)); }
    livePilot(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/live-pilot`, data)); }
    testDeliver(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/test-deliver`, data)); }
    publish(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/publish`, data)); }
    rollback(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/rollback`, data)); }
    changeMode(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/mode`, data)); }
    enable(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/enable`, data)); }
    disable(id, data) { return this.#call(() => this.client.post(`${this.basePath}/policies/${id}/disable`, data)); }
    effective(params = {}) { return this.#call(() => this.client.get(`${this.basePath}/effective`, { params })); }
    listDispatches(params = {}) { return this.#call(() => this.client.get(`${this.basePath}/dispatches`, { params })); }
    getDispatch(id) { return this.#call(() => this.client.get(`${this.basePath}/dispatches/${id}`)); }
    explainDispatch(id) { return this.#call(() => this.client.get(`${this.basePath}/dispatches/${id}/explain`)); }
    recoverDelivery(dispatchId, intentId, data) {
        return this.#call(() => this.client.post(`${this.basePath}/dispatches/${dispatchId}/intents/${intentId}/recovery`, data));
    }
    previewResult(id) { return this.#call(() => this.client.get(`${this.basePath}/dispatches/${id}/preview-result`)); }
    livePilotResult(id) { return this.#call(() => this.client.get(`${this.basePath}/dispatches/${id}/live-pilot-result`)); }
    testResult(id) { return this.#call(() => this.client.get(`${this.basePath}/dispatches/${id}/test-result`)); }
    exportRecipients(id) { return this.#call(() => this.client.get(`${this.basePath}/dispatches/${id}/recipients`)); }
}
